var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1745463897297,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4111,
    id: "mx_n_1745463897298",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M556.088889 609.616162h-88.307071V124.121212c0-13.187879 8.791919-22.109091 22.109091-22.109091h44.088889c13.187879 0 22.109091 8.791919 22.109091 22.109091v485.49495z m0 0",
    fill: "#1890FF",
    "p-id": 4112
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M714.989899 371.2l30.90101 30.90101c8.791919 8.791919 8.791919 22.109091 0 30.90101l-218.50505 218.505051c-8.791919 8.791919-22.109091 8.791919-30.901011 0L450.19798 605.090909l233.890909-233.890909c8.791919-8.791919 22.109091-8.791919 30.90101 0z m0 0",
    fill: "#1890FF",
    "p-id": 4113
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M573.80202 605.090909l-46.286868 46.286869c-8.791919 8.791919-22.109091 8.791919-30.901011 0l-218.50505-218.505051c-8.791919-8.791919-8.791919-22.109091 0-30.90101l30.90101-30.90101c8.791919-8.791919 22.109091-8.791919 30.90101 0l233.890909 234.020202z m335.385859-101.494949h-44.088889c-13.187879 0-22.109091 8.791919-22.109091 22.109091v286.90101c0 13.187879-8.791919 22.109091-22.109091 22.109091H202.989899c-13.187879 0-22.109091-8.791919-22.109091-22.109091V525.705051c0-13.187879-8.791919-22.109091-22.109091-22.109091h-43.959596c-13.187879 0-22.109091 8.791919-22.109091 22.109091v375.078787c0 13.187879 8.791919 22.109091 22.109091 22.109091h794.375758c13.187879 0 22.109091-8.791919 22.109091-22.109091V525.705051c-0.129293-13.187879-8.921212-22.109091-22.109091-22.109091z m0 0",
    fill: "#1890FF",
    "p-id": 4114
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M269.187879 591.90303H136.791919v-88.30707h132.39596c13.187879 0 22.109091 8.791919 22.109091 22.109091v44.088888c0 11.119192-8.791919 22.109091-22.109091 22.109091z m617.890909 0H754.682828c-13.187879 0-22.109091-8.791919-22.109091-22.109091v-44.088888c0-13.187879 8.791919-22.109091 22.109091-22.109091h132.39596v88.30707z m0 0",
    fill: "#1890FF",
    "p-id": 4115
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/导入.94a165f334616b23fe6421e2afbd423d.svg";
export { ForwardRef as ReactComponent };